import { motion, AnimatePresence } from "framer-motion";
import CreditCardPreview from "./credit-card-preview/creditCardPreview";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";

const CardCarousel = ({ selectedCard, selectedCardIndex, direction, handlePrevCard, handleNextCard }) => {
  const isNewCard = selectedCard?.blocked && selectedCard?.blockedReason === "CARTAO_NOVO_SEM_DESBLOQUEIO";
  return (
    <div className="card-carousel-container col-md-12" style={{ display: 'flex', flexDirection: 'row' }}>
      <button className="button-previous" style={{ marginTop: "110px" }} onClick={handlePrevCard}>
        <IoIosArrowDropleftCircle size={30} color="var(--primary-color)" />
      </button>

      <div className="card-wrapper col-md-10">
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedCardIndex}
            initial={{ x: direction * 200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -direction * 200, opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <CreditCardPreview
              number={isNewCard ? "0000" : selectedCard.lastFour}
              name={selectedCard.cardholder}
              expiry={selectedCard.expirationDate}
              focused="number"
            />
          </motion.div>
        </AnimatePresence>
      </div>

      <button className="button-next" style={{ marginLeft: "11px", marginTop: "110px" }} onClick={handleNextCard}>
        <IoIosArrowDroprightCircle size={30} color="var(--primary-color)" />
      </button>
    </div>
  );
};

export default CardCarousel;
